export const DRUPAL_ROUTES = [
  '/api/v2',
  '/card-shop',
  '/sites/default/',
  '/admin/',
]

export function getPathFromUrl(url?: string | null | undefined): string {
  if (!url) {
    return ''
  }
  return url.replace(/^https?:\/\/[^/]+/, '')
}

export function isDrupalRouted(path: string): boolean {
  return path.startsWith('http') || DRUPAL_ROUTES.some((v) => path.includes(v))
}
